import { Model } from './model';
import * as moment from 'moment';
import { BatchLine } from './batch-line';

export class QuotaMovementsBatch extends Model {
  id: number;
  date: Date;
  name: string;
  mode: string;
  get_mode_display: string;
  state: string;
  get_state_display: string;
  year: string;
  lines: BatchLine[];

  constructor(values: Object = {}) {
    super(values);
  }

  public isEditable() {
    return this.state === 'draft';
  }

  public isDeletable() {
    return this.state === 'draft';
  }

  public apiMap(values: Object = {}) {
    const batch = new QuotaMovementsBatch(values);

    if (values['date']) {
      batch.date = new Date(values['date']);
    }

    if (values['batch_lines_set']) {
      batch.lines = [];
      for (const record of values['batch_lines_set']) {
        batch.lines.push(new BatchLine().apiMap(record));
      }
    }

    return batch;
  }

  public serialize() {
    const record = super.serialize();

    if (this.date) {
      record['date'] = moment(this.date).format('YYYY-MM-DD');
    }

    return record;
  }

  public equals(obj: QuotaMovementsBatch): boolean {
    if (this.mode !== obj.mode) {
      return false;
    }

    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/_models/quota-movements-batch.ts